// NOTA: ENDPOINTS QUE LLEVEN PARAMS, LOS USAMOS POR MEDIO DE :params LUEGO EN EL HOOK LE AVISAMOS
// NOTA: :id, :url, :slug <-- únicamente para lo que vendría ser detalle de registro.

// ------------------------- 🔥 ENDPOINTS
import { AUTH_ENDPOINTS } from "./Public/_Auth/_MODULES/_API";
import { TAGS_ENDPOINTS } from "./Private/_Tags/_MODULES/_API";
import { USERS_ENDPOINTS } from "./Private/_Profile/_MODULES/_API";
import { PROJECTS_ENDPOINTS } from "./Private/_Projects/_MODULES/_API";
import { COMPANIES_ENDPOINTS } from "./Private/_Companies/_MODULES/_API";
import { PERSONAL_VAULT_ENDPOINTS } from "./Private/_PersonalVault/_MODULES/_API";
import { MANUALS_ENDPOINTS } from "./Private/_Manuals/_MODULES/_API";
import { COURSES_ENDPOINTS } from "./Private/_Courses/_MODULES/_API";
import { LIBRARY_ENDPOINTS } from "./Private/_Library/_MODULES/_API";
import { SAVINGS_ENDPOINTS } from "./Private/_Savings/_MODULES/_API";
import { MONTHLY_FINANCE_ENDPOINTS } from "./Private/_MonthlyExpenses/_MODULES/_API";
import { SNIPPETS_ENDPOINTS } from "./Private/_Snippets/_MODULES/_API";
import { WISHLIST_ENDPOINTS } from "./Private/_Wishlist/_MODULES/_API";
import { CONTACTS_ENDPOINTS } from "./Private/_Contacts/_MODULES/_API";
import { NOTEBOOK_ENDPOINTS } from "./Private/_Notebook/_MODULES/_API";
import { STICKY_NOTES_ENDPOINTS } from "./Private/_StickyNotes/_MODULES/_API";
import { CENTER_ENDPOINTS } from "./Private/_Center/_MODULES/_API";


// Siempre acompañado del spread (...ENDPOINT)
export const API_LOAD_ENDPOINTS = {

    ...AUTH_ENDPOINTS,
    ...USERS_ENDPOINTS,
    ...COMPANIES_ENDPOINTS,
    ...PROJECTS_ENDPOINTS,
    ...PERSONAL_VAULT_ENDPOINTS,
    ...MANUALS_ENDPOINTS,
    ...LIBRARY_ENDPOINTS,
    ...SAVINGS_ENDPOINTS,
    ...MONTHLY_FINANCE_ENDPOINTS,
    ...SNIPPETS_ENDPOINTS,
    ...WISHLIST_ENDPOINTS,
    ...CONTACTS_ENDPOINTS,
    ...NOTEBOOK_ENDPOINTS,
    ...STICKY_NOTES_ENDPOINTS,
    ...COURSES_ENDPOINTS,
    ...TAGS_ENDPOINTS,
    ...CENTER_ENDPOINTS,

};
